<div class="d-flex">
    <button
        class="cmps-button--no-bg"
        cmpsButton
        [disabled]="previousDisabled"
        (click)="previous.emit()"
    >
        <cmps-icon svgIcon="chevron-left"></cmps-icon>&nbsp;
        <span cmpsButtonLabel>{{ _i18n._9631_PREV | translate }}</span>
    </button>
    <button
        class="cmps-button--no-bg"
        cmpsButton
        [disabled]="nextDisabled"
        (click)="next.emit()"
    >
        <span cmpsButtonLabel>{{ _i18n._9632_NEXT | translate }}</span
        >&nbsp;
        <cmps-icon svgIcon="chevron-right"></cmps-icon>
    </button>
</div>
